exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".org-main[data-v-c6dd02e0]{border-top:1px solid #dedede;height:100%}.cont-list[data-v-c6dd02e0]{height:100%;overflow:auto;flex:1}.news-title[data-v-c6dd02e0]{font-size:15px;font-weight:600;margin-bottom:.7rem;max-height:40px;overflow:hidden}.news-info[data-v-c6dd02e0]{font-size:12px;justify-content:space-between;color:#7d7d7d}.collect[data-v-c6dd02e0]{align-items:center;justify-content:space-between}.split-info[data-v-c6dd02e0]{height:1px}.item-info[data-v-c6dd02e0]{padding:.6rem 1rem .5rem}.slide-fade-enter-active[data-v-c6dd02e0]{transition:all .4s ease}.slide-fade-leave-active[data-v-c6dd02e0]{transition:all .2s ease}.slide-fade-enter[data-v-c6dd02e0]{opacity:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c6dd02e0","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/overview/TabList.vue
// module id = 908
// module chunks = 0